<div class="col-12">
  <app-property-attributes-view [prop]="prop" [category]="category"
    [openInEditionGroupCode]="editGroupCode"></app-property-attributes-view>
</div>
<div class="col-12 room">
  <app-property-room-table *ngIf="isRoomFeatureAvailable" [prop]="prop"></app-property-room-table>
</div>
<div class="col-12 doc">
  <app-property-doc-view [prop]="prop" [category]="category"></app-property-doc-view>
</div>